import { render, staticRenderFns } from "./ClaimPointLink.vue?vue&type=template&id=1989ac59"
import script from "./ClaimPointLink.vue?vue&type=script&lang=js"
export * from "./ClaimPointLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports